export default "__VITE_PUBLIC_ASSET__608a8d81__"